const embedModeEnv = process.env.REACT_APP_EMBED_MODE;

// Default is clean embed mode unless explicitly disabled with "false".
export const isCleanEmbedMode = `${embedModeEnv}`.toLowerCase() !== 'false';